export default {
  nav: {
    home: 'Home',
    video: 'Video Surveillance',
    alarm: 'Alarm Systems',
    solutions: 'Solutions',
    care: 'SSG Care',
    planner: 'Camera Planner',
    areas: 'Service Areas',
    about: 'About Us',
    contact: 'Contact',
  },
  dropdown: {
    allSolutions: 'View all solutions',
    homeGrounds: 'Home & Property',
    retailGastro: 'Retail & Hospitality',
    officePractice: 'Office & Practice',
    warehouseLogistics: 'Warehouse & Logistics',
    workshopTrade: 'Workshop & Trade',
    apartments: 'Apartment Buildings & Real Estate',
    cameraTypes: 'Camera Types',
    services: 'Services',
    technology: 'Technology',
  },
  footer: {
    brandLine: 'Security technology for private & commercial',
    area: 'Hainburg · Rhine-Main region',
    services: 'Services',
    solutions: 'Solutions',
    forWhom: 'For Whom',
    contact: 'Contact',
    areaLabel: 'Service area Rhine-Main',
    privateCustomers: 'Private customers',
    businessCustomers: 'Business customers',
    allSolutions: 'All solutions',
    faq: 'FAQ',
    rights: 'All rights reserved.',
    impressum: 'Imprint',
    privacy: 'Privacy Policy',
    cookieSettings: 'Cookie settings',
  },
  related: {
    eyebrow: 'More solutions',
    title: 'Discover other property types',
    viewAll: 'View all solutions',
  },
};